(function () {
  'use strict';

  if (window.SidalihCouponsLoaded) return;
  window.SidalihCouponsLoaded = true;

  const ROOT_SELECTOR = '[data-sdc-root]';
  const NATIVE_REMOVE_SELECTOR = [
    '[data-remove-discount]',
    '[data-remove-discount-code]',
    '[data-discount-remove]',
    '[data-discount-code-remove]',
    '[data-cart-discount-remove]',
    'button[name="remove_discount"]',
    '.hdt-cart-discount__remove',
    '.hdt-discount-code__remove',
    '.hdt-discounts__remove',
    '.t4s-cart-discount__remove',
    '.t4s-discount-code__remove'
  ].join(',');
  const CART_HOST_SELECTOR = [
    'hdt-cart-drawer',
    'hdt-drawer#CartDrawer',
    'hdt-drawer[id*="cart" i]',
    '#CartDrawer',
    '.hdt-cart-drawer',
    '.hdt-drawer--cart',
    '.hdt-drawer[id*="cart" i]',
    '.t4s-drawer--cart',
    '.t4s-drawer',
    '#t4s-mini_cart',
    '#nt_cart_canvas',
    '.cart-drawer',
    '[data-cart-drawer]'
  ].join(',');
  const CART_FOOTER_SELECTOR = [
    '.hdt-mini-cart__footer',
    '.hdt-cart-drawer__footer',
    '.hdt-cart-footer',
    '.hdt-drawer__footer',
    '.hdt-drawer__bottom',
    '.hdt-mini-cart__bottom',
    '[data-cart-footer]',
    '.t4s-drawer__bottom',
    '.t4s-mini_cart__footer',
    '.mini_cart_footer',
    '.cart-drawer__footer'
  ].join(',');
  const CART_ITEMS_SELECTOR = [
    '.hdt-mini-cart__items',
    '.hdt-cart-drawer__items',
    '.hdt-cart-items',
    '[data-cart-items]',
    '.t4s-mini_cart__items',
    '.t4s-cart-items',
    '.mini_cart_wrap',
    'cart-drawer-items'
  ].join(',');

  function syncCouponScrollLock() {
    const hasOpenCouponDrawer = !!document.querySelector(
      `${ROOT_SELECTOR} [data-sdc-drawer].is-open`
    );

    document.documentElement.classList.toggle(
      'sdc-lock-scroll',
      hasOpenCouponDrawer
    );

    if (document.body) {
      document.body.classList.toggle(
        'sdc-lock-scroll',
        hasOpenCouponDrawer
      );
    }
  }

  class SidalihCoupons {
    constructor(root) {
      this.root = root;
      this.drawer = root.querySelector('[data-sdc-drawer]');
      this.input = root.querySelector('[data-sdc-input]');
      this.applyButton = root.querySelector('[data-sdc-manual-apply]');
      this.messages = Array.from(root.querySelectorAll('[data-sdc-message]'));
      this.isBusy = false;
      this.appliedCode = '';
      this.lastFocusedElement = null;

      this.root.dataset.sdcInitialized = 'true';
      this.root.sidalihCoupons = this;
      this.bindEvents();
      window.requestAnimationFrame(() => this.positionAfterCartItems());
      this.syncCart();
    }

    bindEvents() {
      this.root.querySelectorAll('[data-sdc-open]').forEach((button) => {
        button.addEventListener('click', () => this.openDrawer(button));
      });

      this.root.querySelectorAll('[data-sdc-close]').forEach((button) => {
        button.addEventListener('click', () => this.closeDrawer());
      });

      this.root.querySelectorAll('[data-sdc-coupon]').forEach((button) => {
        button.addEventListener('click', () => {
          const code = button.dataset.sdcCoupon || '';

          if (
            this.appliedCode &&
            this.normalizeCode(code) === this.normalizeCode(this.appliedCode)
          ) {
            this.showMessage(
              this.text('alreadyApplied', this.appliedCode),
              'success'
            );
            return;
          }

          this.applyCoupon(code);
        });
      });

      if (this.applyButton) {
        this.applyButton.addEventListener('click', () => {
          if (this.appliedCode) {
            this.removeCoupon();
          } else {
            this.applyCoupon(this.input ? this.input.value : '');
          }
        });
      }

      if (this.input) {
        this.input.addEventListener('input', () => {
          if (this.appliedCode) return;
          this.setInputInvalid(false);
          this.clearMessage();
        });

        this.input.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter') return;
          event.preventDefault();
          if (this.appliedCode) return;
          this.applyCoupon(this.input.value);
        });
      }

      document.addEventListener('keydown', (event) => {
        if (
          event.key === 'Escape' &&
          this.drawer &&
          this.drawer.classList.contains('is-open')
        ) {
          this.closeDrawer();
        }
      });
    }

    openDrawer(trigger) {
      if (!this.drawer) return;

      this.lastFocusedElement = trigger || document.activeElement;
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      this.root.querySelectorAll('[data-sdc-open]').forEach((button) => {
        button.setAttribute('aria-expanded', 'true');
      });
      syncCouponScrollLock();

      window.requestAnimationFrame(() => {
        const closeButton = this.drawer.querySelector('[data-sdc-close]');
        if (closeButton) closeButton.focus();
      });
    }

    closeDrawer(options) {
      if (!this.drawer) return;

      const shouldRestoreFocus = !options || options.restoreFocus !== false;

      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      this.root.querySelectorAll('[data-sdc-open]').forEach((button) => {
        button.setAttribute('aria-expanded', 'false');
      });
      syncCouponScrollLock();

      if (
        shouldRestoreFocus &&
        this.lastFocusedElement &&
        this.lastFocusedElement.isConnected &&
        typeof this.lastFocusedElement.focus === 'function'
      ) {
        this.lastFocusedElement.focus();
      }

      this.lastFocusedElement = null;
    }

    positionAfterCartItems() {
      if (!this.root.isConnected) return;

      const cartHost = this.root.closest(CART_HOST_SELECTOR);
      if (!cartHost) return;

      const footer = cartHost.querySelector(CART_FOOTER_SELECTOR);

      if (footer && footer !== this.root && !this.root.contains(footer)) {
        if (footer.previousElementSibling !== this.root) {
          footer.parentNode.insertBefore(this.root, footer);
        }
        this.root.dataset.sdcPositioned = 'before-footer';
        return;
      }

      let items = cartHost.querySelector(CART_ITEMS_SELECTOR);

      if (!items) {
        const firstItem = cartHost.querySelector(
          '.hdt-mini-cart__item, .hdt-cart-item, .t4s-mini_cart__item, .mini_cart_item, [data-cart-item]'
        );
        items = firstItem ? firstItem.parentElement : null;
      }

      if (items && items !== this.root && !this.root.contains(items)) {
        if (items.nextElementSibling !== this.root) {
          items.insertAdjacentElement('afterend', this.root);
        }
        this.root.dataset.sdcPositioned = 'after-items';
      }
    }

    async applyCoupon(rawCode) {
      const code = String(rawCode || '').trim();
      const previousCode = this.appliedCode;

      if (this.isBusy) return;

      if (
        previousCode &&
        this.normalizeCode(code) === this.normalizeCode(previousCode)
      ) {
        this.showMessage(this.text('alreadyApplied', previousCode), 'success');
        return;
      }

      if (!code) {
        this.setInputInvalid(true);
        this.showMessage(this.text('emptyCode'), 'error');
        if (this.input) this.input.focus();
        return;
      }

      this.isBusy = true;
      this.clearMessage();
      this.setInputInvalid(false);
      this.setBusy(true);
      this.setCouponLoading(code, true);

      try {
        const cart = await this.updateDiscount(code);
        const status = this.getCodeStatus(cart, code);

        if (!status.applicable) {
          if (previousCode) {
            const rollback = await this.restoreDiscount(previousCode);

            if (rollback.restored) {
              this.setAppliedCode(previousCode);
              this.showMessage(
                this.text('replacementRejected', previousCode),
                'error'
              );
              this.refreshThemeCart(
                rollback.cart,
                previousCode,
                'restored'
              );
            } else {
              this.clearAppliedCode();
              this.showMessage(this.text('restoreError'), 'error');
              this.refreshThemeCart(cart, code, 'rejected');
            }
          } else {
            this.clearAppliedCode();
            this.setInputInvalid(true);
            this.showMessage(
              cart && cart.item_count === 0
                ? this.text('emptyCart')
                : this.text('notApplicable'),
              'error'
            );
          }
          return;
        }

        this.setAppliedCode(code);
        this.showMessage(
          previousCode
            ? this.text('replaced', code)
            : this.text('applied', code),
          'success'
        );
        this.refreshThemeCart(
          cart,
          code,
          previousCode ? 'replaced' : 'applied'
        );

        if (this.drawer && this.drawer.classList.contains('is-open')) {
          this.closeDrawer();
        }
      } catch (error) {
        console.error('[Sidalih Coupons]', error);

        if (previousCode) {
          const rollback = await this.restoreDiscount(previousCode);

          if (rollback.restored) {
            this.setAppliedCode(previousCode);
            this.showMessage(this.text('networkKept', previousCode), 'error');
            this.refreshThemeCart(rollback.cart, previousCode, 'restored');
          } else {
            this.clearAppliedCode();
            this.showMessage(this.text('restoreError'), 'error');
          }
        } else {
          this.showMessage(this.text('networkError'), 'error');
        }
      } finally {
        this.setCouponLoading(code, false);
        this.setBusy(false);
        this.isBusy = false;
      }
    }

    async updateDiscount(code) {
      const response = await fetch(this.cartUrl('cart/update.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ discount: code })
      });

      const cart = await this.readJson(response);

      if (!response.ok) {
        throw new Error(
          (cart && (cart.description || cart.message)) ||
            'Shopify cart update failed'
        );
      }

      return cart;
    }

    async restoreDiscount(code) {
      try {
        const cart = await this.updateDiscount(code);
        return {
          restored: this.getCodeStatus(cart, code).applicable,
          cart
        };
      } catch (error) {
        console.error('[Sidalih Coupons] Rollback failed', error);
        return { restored: false, cart: null };
      }
    }

    setAppliedCode(code) {
      this.appliedCode = code;
      this.clearAppliedStates();
      this.setCouponApplied(code);

      if (this.input) this.input.value = code;

      this.setInputInvalid(false);
      this.updateControlState();
    }

    clearAppliedCode() {
      this.appliedCode = '';
      this.clearAppliedStates();

      if (this.input) this.input.value = '';

      this.updateControlState();
    }

    async removeCoupon() {
      if (this.isBusy || !this.appliedCode) return;

      const removedCode = this.appliedCode;
      this.isBusy = true;
      this.clearMessage();
      this.setInputInvalid(false);
      this.setBusy(true);

      try {
        const cart = await this.updateDiscount('');
        this.clearAppliedCode();
        this.showMessage(this.text('removed', removedCode), 'success');
        this.refreshThemeCart(cart, removedCode, 'removed');

        window.requestAnimationFrame(() => {
          if (this.input && this.input.isConnected) this.input.focus();
        });
      } catch (error) {
        console.error('[Sidalih Coupons]', error);
        this.showMessage(this.text('removeError'), 'error');
      } finally {
        this.setBusy(false);
        this.isBusy = false;
      }
    }

    getCodeStatus(cart, requestedCode) {
      const wanted = this.normalizeCode(requestedCode);
      const listedCodes = Array.isArray(cart && cart.discount_codes)
        ? cart.discount_codes
        : [];

      const directMatch = listedCodes.find((item) => {
        const code = typeof item === 'string' ? item : item && item.code;
        return this.normalizeCode(code) === wanted;
      });

      if (directMatch) {
        return {
          applicable:
            typeof directMatch === 'string' || directMatch.applicable !== false,
          source: 'discount_codes'
        };
      }

      const applicationMatch = this.getDiscountApplications(cart).some(
        (application) => {
          const type = String(application.type || '').toLowerCase();
          const isManualCode = !type || type === 'discount_code';
          const title = application.code || application.title || '';

          return isManualCode && this.normalizeCode(title) === wanted;
        }
      );

      return {
        applicable: applicationMatch,
        source: applicationMatch ? 'discount_applications' : 'not_found'
      };
    }

    getAppliedCodes(cart) {
      const codes = new Set();

      if (Array.isArray(cart && cart.discount_codes)) {
        cart.discount_codes.forEach((item) => {
          const code = typeof item === 'string' ? item : item && item.code;
          const applicable =
            typeof item === 'string' || (item && item.applicable !== false);

          if (code && applicable) codes.add(String(code).trim());
        });
      }

      this.getDiscountApplications(cart).forEach((application) => {
        const type = String(application.type || '').toLowerCase();
        const code = application.code || application.title || '';

        if (code && (!type || type === 'discount_code')) {
          codes.add(String(code).trim());
        }
      });

      return Array.from(codes).filter(Boolean);
    }

    getDiscountApplications(cart) {
      const applications = [];

      const addApplications = (items) => {
        if (Array.isArray(items)) {
          items.forEach((item) => {
            if (item) applications.push(item.discount_application || item);
          });
        }
      };

      if (!cart) return applications;

      addApplications(cart.cart_level_discount_applications);
      addApplications(cart.discount_applications);

      if (Array.isArray(cart.items)) {
        cart.items.forEach((item) => {
          addApplications(item.line_level_discount_allocations);
          addApplications(item.discount_allocations);
        });
      }

      return applications;
    }

    async syncCart() {
      try {
        const response = await fetch(this.cartUrl('cart.js'), {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });

        if (!response.ok) return;

        const cart = await response.json();
        this.syncFromCart(cart);
      } catch (error) {
        console.warn('[Sidalih Coupons] Cart sync failed', error);
      }
    }

    syncFromCart(cart) {
      if (!cart) return;

      const hasItems = Number(cart.item_count || 0) > 0;
      this.root.hidden = !hasItems;

      if (!hasItems) {
        this.clearAppliedCode();
        return;
      }

      const codes = this.getAppliedCodes(cart);
      this.appliedCode = codes[0] || '';
      this.clearAppliedStates();

      if (this.appliedCode) {
        this.setCouponApplied(this.appliedCode);
        if (this.input) this.input.value = this.appliedCode;
      } else if (this.input) {
        this.input.value = '';
      }

      this.updateControlState();
      window.requestAnimationFrame(() => this.positionAfterCartItems());
    }

    refreshThemeCart(cart, code, action) {
      const detail = { cart, code, action, source: 'sidalih-coupons' };
      const hasKallesFive = Boolean(
        document.querySelector('hdt-cart-drawer') ||
          (window.customElements &&
            window.customElements.get('hdt-cart-drawer'))
      );

      if (hasKallesFive) {
        document.dispatchEvent(
          new CustomEvent('cart:reload', { bubbles: true, detail })
        );
      } else {
        document.dispatchEvent(
          new CustomEvent('cart:refresh:opend', { bubbles: true, detail })
        );
      }

      document.dispatchEvent(
        new CustomEvent('cart:updated', { bubbles: true, detail })
      );
      document.dispatchEvent(
        new CustomEvent(`sidalih:coupon-${action}`, {
          bubbles: true,
          detail
        })
      );
    }

    setCouponLoading(code, loading) {
      const wanted = this.normalizeCode(code);

      this.root.querySelectorAll('[data-sdc-coupon]').forEach((button) => {
        if (this.normalizeCode(button.dataset.sdcCoupon) !== wanted) return;

        const card = button.closest('.sdc__coupon, .sdc__full-coupon');
        if (card) card.classList.toggle('is-loading', loading);
        button.setAttribute('aria-busy', loading ? 'true' : 'false');
      });
    }

    setCouponApplied(code) {
      const wanted = this.normalizeCode(code);

      this.root.querySelectorAll('[data-sdc-coupon]').forEach((button) => {
        if (this.normalizeCode(button.dataset.sdcCoupon) !== wanted) return;

        const card = button.closest('.sdc__coupon, .sdc__full-coupon');
        if (card) card.classList.add('is-applied');
        button.setAttribute('aria-pressed', 'true');
      });
    }

    clearAppliedStates() {
      this.root
        .querySelectorAll('.sdc__coupon.is-applied, .sdc__full-coupon.is-applied')
        .forEach((element) => element.classList.remove('is-applied'));

      this.root.querySelectorAll('[data-sdc-coupon]').forEach((button) => {
        button.setAttribute('aria-pressed', 'false');
      });
    }

    setBusy(isBusy) {
      this.root.classList.toggle('is-busy', isBusy);
      this.root.setAttribute('aria-busy', isBusy ? 'true' : 'false');

      if (this.applyButton) this.applyButton.disabled = isBusy;
      this.updateControlState(isBusy);
    }

    updateControlState(forceBusy) {
      const busy = typeof forceBusy === 'boolean' ? forceBusy : this.isBusy;
      const hasCode = Boolean(this.appliedCode);

      this.root.classList.toggle('has-applied-code', hasCode);

      if (this.input) {
        this.input.readOnly = busy || hasCode;
        this.input.setAttribute('aria-readonly', busy || hasCode ? 'true' : 'false');
      }

      if (this.applyButton) {
        this.applyButton.disabled = busy;
        this.applyButton.setAttribute(
          'aria-label',
          hasCode ? this.text('removeButton') : this.text('applyButton')
        );
      }

      this.root.querySelectorAll('[data-sdc-coupon]').forEach((button) => {
        button.disabled = busy;
      });
    }

    setInputInvalid(isInvalid) {
      const manual = this.root.querySelector('.sdc__manual');
      if (manual) manual.classList.toggle('is-invalid', isInvalid);
      if (this.input) {
        this.input.setAttribute('aria-invalid', isInvalid ? 'true' : 'false');
      }
    }

    showMessage(message, type) {
      this.messages.forEach((element) => {
        element.textContent = message;
        element.className = 'sdc__message is-visible';
        element.classList.add(
          type === 'success' ? 'is-success' : 'is-error'
        );
        element.setAttribute('role', type === 'error' ? 'alert' : 'status');
      });
    }

    clearMessage() {
      this.messages.forEach((element) => {
        element.textContent = '';
        element.className = 'sdc__message';
        element.setAttribute('role', 'status');
      });
    }

    text(key, code) {
      const ar = this.isArabic();
      const messages = {
        emptyCode: ar
          ? 'اكتب كود الخصم أولًا.'
          : 'Enter a discount code first.',
        emptyCart: ar
          ? 'أضف منتجًا إلى السلة أولًا، ثم جرّب كود الخصم.'
          : 'Add an item to the cart before applying a discount code.',
        notApplicable: ar
          ? 'الكود غير صالح، منتهي، أو لا ينطبق على محتويات سلتك.'
          : 'This code is invalid, expired, or not applicable to your cart.',
        networkError: ar
          ? 'تعذر الاتصال بالسلة. حاول مرة أخرى بعد قليل.'
          : 'The cart could not be reached. Please try again.',
        applied: ar
          ? `تم تطبيق كود الخصم ${code} بنجاح.`
          : `Discount code ${code} was applied successfully.`,
        alreadyApplied: ar
          ? `كود الخصم ${code} مطبّق بالفعل.`
          : `Discount code ${code} is already applied.`,
        replaced: ar
          ? `تم استبدال الكود السابق وتطبيق ${code} بنجاح.`
          : `The previous code was replaced with ${code}.`,
        replacementRejected: ar
          ? `الكوبون الجديد غير مناسب لسلتك؛ أبقينا الكود ${code} مطبّقًا.`
          : `The new coupon is not applicable. ${code} remains applied.`,
        networkKept: ar
          ? `تعذر فحص الكوبون الجديد؛ أبقينا الكود ${code} مطبّقًا.`
          : `The new coupon could not be checked. ${code} remains applied.`,
        restoreError: ar
          ? 'تعذر تطبيق الكوبون الجديد وتعذر استعادة القديم. أعد المحاولة.'
          : 'The new coupon failed and the previous code could not be restored.',
        removed: ar
          ? `تمت إزالة كود الخصم ${code}. يمكنك إضافة كود جديد.`
          : `Discount code ${code} was removed. You can apply a new code.`,
        removeError: ar
          ? 'تعذرت إزالة كود الخصم. حاول مرة أخرى.'
          : 'The discount code could not be removed. Please try again.',
        removeButton: ar ? 'إزالة كود الخصم' : 'Remove discount code',
        applyButton: ar ? 'تطبيق كود الخصم' : 'Apply discount code'
      };

      return messages[key] || '';
    }

    isArabic() {
      return String(this.root.dataset.locale || '')
        .toLowerCase()
        .startsWith('ar');
    }

    normalizeCode(code) {
      return String(code || '').trim().toLocaleLowerCase();
    }

    cartUrl(path) {
      const root =
        window.Shopify && window.Shopify.routes
          ? window.Shopify.routes.root
          : '/';
      return `${root}${path}`;
    }

    async readJson(response) {
      try {
        return await response.json();
      } catch (error) {
        return null;
      }
    }
  }

  function initSidalihCoupons(scope) {
    const roots = [];

    if (scope && scope.matches && scope.matches(ROOT_SELECTOR)) {
      roots.push(scope);
    }

    if (scope && scope.querySelectorAll) {
      roots.push(...scope.querySelectorAll(ROOT_SELECTOR));
    }

    roots.forEach((root) => {
      if (root.dataset.sdcInitialized === 'true') return;

      const cartHost = root.closest(CART_HOST_SELECTOR);
      const existingRoot = cartHost
        ? Array.from(cartHost.querySelectorAll(ROOT_SELECTOR)).find(
            (candidate) =>
              candidate !== root && candidate.sidalihCoupons
          )
        : null;

      if (existingRoot) {
        root.remove();
        return;
      }

      new SidalihCoupons(root);
    });
  }

  function getInstances() {
    return Array.from(document.querySelectorAll(ROOT_SELECTOR))
      .map((root) => root.sidalihCoupons)
      .filter(Boolean);
  }

  function getActiveInstance() {
    return getInstances().find((instance) => instance.appliedCode);
  }

  function bindNativeRemoveButtons() {
    document.addEventListener(
      'click',
      (event) => {
        const target = event.target;
        if (!target || typeof target.closest !== 'function') return;

        const trigger = target.closest(NATIVE_REMOVE_SELECTOR);
        if (!trigger) return;

        const instance = getActiveInstance();
        if (!instance) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        instance.removeCoupon();
      },
      true
    );
  }

  function bindCartSyncEvents() {
    const sync = (event) => {
      const detail = event && event.detail ? event.detail : {};
      if (detail.source === 'sidalih-coupons') return;

      const cart = detail.cart || (detail.data && detail.data.cart);

      getInstances().forEach((instance) => {
        if (cart) {
          instance.syncFromCart(cart);
          return;
        }

        window.clearTimeout(instance.cartSyncTimer);
        instance.cartSyncTimer = window.setTimeout(
          () => instance.syncCart(),
          80
        );
      });
    };

    ['cart:updated', 'cart:reload', 'cart:refresh:opend', 'cart:change'].forEach(
      (eventName) => document.addEventListener(eventName, sync)
    );
  }

  function start() {
    initSidalihCoupons(document);
    bindNativeRemoveButtons();
    bindCartSyncEvents();

    window.sidalihRemoveCoupon = () => {
      const instance = getActiveInstance();
      if (instance) instance.removeCoupon();
    };

    if (!document.body || !window.MutationObserver) return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') {
          const target = mutation.target;

          if (
            mutation.attributeName === 'open' &&
            target &&
            typeof target.matches === 'function' &&
            target.matches(CART_HOST_SELECTOR) &&
            !target.hasAttribute('open')
          ) {
            getInstances().forEach((instance) => {
              instance.closeDrawer({ restoreFocus: false });
            });
          }

          return;
        }

        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) initSidalihCoupons(node);
        });

        syncCouponScrollLock();
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['open']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initSidalihCoupons(event.target);
  });
})();
